import SkipLink from './SkipLink';

export default SkipLink;
